import { Switch, Route } from "wouter";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { HelmetProvider } from "react-helmet-async";
import { QuoteDrawerProvider } from "@/contexts/QuoteDrawerContext";
import { CareerApplicationProvider } from "@/contexts/CareerApplicationContext";
import { Helmet } from 'react-helmet-async';
import NotFound from "@/pages/not-found";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import OurServices from "@/pages/OurServices";
import Portfolio from "@/pages/Portfolio";
import Careers from "@/pages/Careers";
import {
  Branding,
  CloudServices,
  Consulting,
  CustomApps,
  CyberSecurity,
  DigitalMarketing,
  DomainRegistration,
  ECommerce,
  ERPCRM,
  EmailHosting,
  MaintenanceSupport,
  MobileAppDevelopment,
  SEO,
  SoftwareDevelopment,
  UIUX,
  WebDesignDevelopment,
  WebDesignDevelopmentUSA,
  WebHosting,
  DataAnalytics,
  WebDesignDevelopmentDubai,
  WebDesignDevelopmentAlAin,
  WebDesignDevelopmentSharjah,
  WebDesignDevelopmentAjman,
  WebDesignDevelopmentFujairah,
  WebDesignDevelopmentRasAlKhaimah,
  WebDesignDevelopmentUmmAlQuwain,
  WebDesignDevelopmentUAE
} from "@/pages/services";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import WhatsAppFloatingButton from "@/components/WhatsAppFloatingButton";
import QuoteDrawer from "@/components/QuoteDrawer"; 
import PrivacyPolicy from '@/pages/PrivacyPolicy';
import TermsOfService from '@/pages/TermsOfService';
import CookiePolicy from '@/pages/CookiePolicy';
import GoogleAnalytics from '@/components/GoogleAnalytics';

// Create a client
const queryClient = new QueryClient();

function MetaTags() {
  return (
    <Helmet>
      <meta name="viewport" content="width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=5, viewport-fit=cover" />
      <meta name="theme-color" content="#06070A" />
      <meta name="description" content="ZeeXSoft - Innovative digital solutions for web, mobile, and cloud technologies" />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
      <style>{
        `
          html {
            scroll-behavior: smooth;
          }
          @media (prefers-reduced-motion: reduce) {
            html {
              scroll-behavior: auto;
            }
          }
        `
      }</style>
    </Helmet>
  );
}

function Router() {
  return (
    <>
      <Header />
      <main className="min-h-screen">
        <Switch>
          <Route path="/" component={Home} />
          <Route path="/about" component={About} />
          <Route path="/careers" component={Careers} />
          <Route path="/contact" component={Contact} />
          <Route path="/blog" component={Blog} />
          <Route path="/blog/:slug" component={BlogPost} />
          <Route path="/portfolio" component={Portfolio} />
          <Route path="/services" component={OurServices} />
          
          {/* Services Routes */}
          <Route path="/branding" component={Branding} />
          <Route path="/cloud-services" component={CloudServices} />
          <Route path="/consulting" component={Consulting} />
          <Route path="/custom-apps" component={CustomApps} />
          <Route path="/cyber-security" component={CyberSecurity} />
          <Route path="/digital-marketing" component={DigitalMarketing} />
          <Route path="/domain-registration" component={DomainRegistration} />
          <Route path="/ecommerce" component={ECommerce} />
          <Route path="/erp-crm" component={ERPCRM} />
          <Route path="/email-hosting" component={EmailHosting} />
          <Route path="/maintenance-support" component={MaintenanceSupport} />
          <Route path="/mobile-app-development" component={MobileAppDevelopment} />
          <Route path="/seo" component={SEO} />
          <Route path="/software-development" component={SoftwareDevelopment} />
          <Route path="/ui-ux" component={UIUX} />
          <Route path="/web-design-development" component={WebDesignDevelopment} />
          <Route path="/web-design-usa" component={WebDesignDevelopmentUSA} />
          <Route path="/web-hosting" component={WebHosting} />
          <Route path="/data-analytics" component={DataAnalytics} />
          <Route path="/web-design-dubai" component={WebDesignDevelopmentDubai} />
          <Route path="/web-design-al-ain" component={WebDesignDevelopmentAlAin} />
          <Route path="/web-design-sharjah" component={WebDesignDevelopmentSharjah} />
          <Route path="/web-design-ajman" component={WebDesignDevelopmentAjman} />
          <Route path="/web-design-fujairah" component={WebDesignDevelopmentFujairah} />
          <Route path="/web-design-ras-al-khaimah" component={WebDesignDevelopmentRasAlKhaimah} />
          <Route path="/web-design-umm-al-quwain" component={WebDesignDevelopmentUmmAlQuwain} />
          <Route path="/web-design-uae" component={WebDesignDevelopmentUAE} />
          <Route path="/privacy-policy" component={PrivacyPolicy} />
          <Route path="/terms-of-service" component={TermsOfService} />
          <Route path="/cookie-policy" component={CookiePolicy} />
          <Route path="*" component={NotFound} />
        </Switch>
      </main>
      <Footer />
      <ScrollToTop />
      <WhatsAppFloatingButton />
      <QuoteDrawer />
    </>
  );
}

// Main App component with all providers
export default function App() {
  return (
    <>
      <GoogleAnalytics />
      <HelmetProvider>
        <MetaTags />
        <QueryClientProvider client={queryClient}>
          <TooltipProvider>
            <QuoteDrawerProvider>
              <CareerApplicationProvider>
                <div className="app">
                  <Router />
                  <Toaster />
                </div>
              </CareerApplicationProvider>
            </QuoteDrawerProvider>
          </TooltipProvider>
        </QueryClientProvider>
      </HelmetProvider>
    </>
  );
}
